import { inject } from '@angular/core';

import { SessionStoreService } from '@frontend/vanilla/core';

import { CommonMethodsService } from '../tracking/common-methods-service';
import { ContactResourceService } from './contact-resource.service';

export const ContactResolver = () => {
    const resource = inject(ContactResourceService);
    const commonMethodService = inject(CommonMethodsService);
    const sessionStorage = inject(SessionStoreService);

    commonMethodService.hideLoader();
    if (sessionStorage.get('navsource') != 'back' && document.getElementsByTagName('lh-login-standalone').length == 0) {
        sessionStorage.remove('navsource');
        commonMethodService.loadSkeleton('HCCSkeleton', 'hcc-skeleton');
    }
    return resource.getInitValues();
};
